<template lang="pug">
.d-flex.flex-wrap.align-center.gap-2.my-4
  .d-flex.flex-wrap.align-center.gap-2.flex-grow-1
    filter-name(ref="nameFilter" :filter.sync="nameFilter" :check-initial-value="true")
    filter-price-to-patient(ref="priceToPatientFilter" :filter.sync="priceToPatientFilter" :check-initial-value="true")
  yz-btn(label="Reset filters" text underline @click="onResetFilters" :disabled="!hasActiveFilters")
</template>

<script>
import FilterName from '../filters/FilterName.vue'
import FilterPriceToPatient from '../filters/FilterPriceToPatient.vue'

export default {
  components: { FilterName, FilterPriceToPatient },
  props: {
    filters: { type: Array, default: () => [] }
  },
  data: () => ({
    isInitializing: false,
    nameFilter: {},
    priceToPatientFilter: {}
  }),
  computed: {
    allFilters () {
      const filters = []
      if (this.nameFilter.key) filters.push(this.nameFilter)
      if (this.priceToPatientFilter.key) {
        if (this.priceToPatientFilter.key === 'between') {
          const values = this.priceToPatientFilter.value
          for (const i in values) { filters.push(values[i]) }
        } else {
          filters.push(this.priceToPatientFilter)
        }
      }
      return filters
    },
    hasActiveFilters () {
      return this.nameFilter.key || this.priceToPatientFilter.key
    }
  },
  watch: {
    filters: {
      immediate: true,
      handler (newFilters) {
        this.initializeFromFilters(newFilters)
      }
    },
    allFilters (newValue) {
      if (!this.isInitializing) {
        this.$emit('update:filters', newValue)
      }
    }
  },
  methods: {
    async initializeFromFilters (filters) {
      if (!filters || filters.length === 0) return
      if (this.isInitializing) return
      if (JSON.stringify(filters) === JSON.stringify(this.allFilters)) return

      this.isInitializing = true

      try {
        const nameKeys = ['name', 'name__ne', 'name__contains', 'name__exclude', 'name__startswith', 'name__endswidth']
        const nameFilterData = filters.find(f => nameKeys.includes(f.key))
        if (nameFilterData) {
          this.nameFilter = { ...nameFilterData }
          await this.$nextTick()
          if (this.$refs.nameFilter) {
            this.$refs.nameFilter.option = nameFilterData.key
            this.$refs.nameFilter.value = nameFilterData.value
            this.$refs.nameFilter.selectedOption = nameFilterData.key
            this.$refs.nameFilter.selectedValue = nameFilterData.value
          }
        }

        const priceKeys = ['price', 'price__ne', 'price__lt', 'price__gt', 'price__gte', 'price__lte']
        const priceFilterData = filters.find(f => priceKeys.includes(f.key))
        const priceBetween = !priceFilterData ? filters.find(f => f.key === 'between' && Array.isArray(f.value) && f.value.some(v => v.key && v.key.startsWith('price'))) : null
        const priceFilter = priceFilterData || priceBetween
        if (priceFilter) {
          this.priceToPatientFilter = { ...priceFilter }
          await this.$nextTick()
          if (this.$refs.priceToPatientFilter) {
            this.$refs.priceToPatientFilter.selectedOption = priceFilter.key
            this.$refs.priceToPatientFilter.option = priceFilter.key
            if (priceFilter.key === 'between' && Array.isArray(priceFilter.value)) {
              this.$refs.priceToPatientFilter.value = Number(priceFilter.value[0].value) / Number(this.$currency.multiplier)
              this.$refs.priceToPatientFilter.endValue = Number(priceFilter.value[1].value) / Number(this.$currency.multiplier)
              this.$refs.priceToPatientFilter.selectedValue = this.$refs.priceToPatientFilter.value
              this.$refs.priceToPatientFilter.selectedEndValue = this.$refs.priceToPatientFilter.endValue
            } else {
              this.$refs.priceToPatientFilter.value = Number(priceFilter.value) / Number(this.$currency.multiplier)
              this.$refs.priceToPatientFilter.selectedValue = this.$refs.priceToPatientFilter.value
            }
          }
        }
      } finally {
        this.isInitializing = false
      }
    },
    resetFilters () {
      this.nameFilter = {}
      this.priceToPatientFilter = {}
    },
    onResetFilters () {
      this.resetFilters()
      this.$emit('reset')
    }
  }
}
</script>
